import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import * as toastModule from 'modules/toast'
import * as peopleModule from 'modules/people'
import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

export default compose(
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user) || null,
        newOrganisationId: idx(state, _ => _.ui.newOrganisationId),
        organisation: idx(state, _ => _.organisation.selected),
      }
    },
    (dispatch) => {
      const actions = {
        ...userActions,
        ...toastModule,
        ...routeActions,
        ...peopleModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    onCreateSubmit: props => (createFields) => {
      props.actions.createUser(createFields)
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        actions, organisation, newOrganisationId
      } = this.props

      if (organisation) {
          actions.getPeopleRequests(organisation)
      }

      if (newOrganisationId && newOrganisationId === organisation.uuid) {
        setTimeout(() => {
          actions.showToast(toastModule.ACTION_BUTTON_TOAST, {
            manual: true,
            actionLabel: 'Invite contributors',
            label: 'Welcome to your new project. To start tracking your Goodnature traps, create new groups and invite contributors to set-up and share traps with you.',
            onActionClick: () => actions.redirect('/dashboard/people/all')
          })
        }, 500)
      }
    },
    shouldComponentUpdate(nextProps) {
      return idx(nextProps, _ => _.location.pathname) !== (idx(this.props, _ => _.location.pathname) || true)
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/core/Dashboard/Dashboard.enhancer.js